module.exports = __webpack_public_path__ + "img/karelia_logo_transparent.62878147.png";